import { Box, TextField as MuiTextField } from "@material-ui/core";
import { ArrayInput, TextField, useRecordSelection } from "react-admin";
import { ListIterator } from "../../common/list/compact-list/ListIterator";
import resourceNames from "../../../common/data/resourceNames";
import { useEffect, useMemo, useState } from "react";
import { useForm } from "react-final-form";
import { useSearchFields } from "../../../common/hooks/useSearchFields";

interface Props {
  source: string;
  filter?: any;
}

export const DriverSelectionList = ({ source, filter }: Props) => {
  const form = useForm();
  const [ids] = useRecordSelection(resourceNames.ADMIN_DRIVERS_VIEW);
  const [searchText, setSearchText] = useState("");

  useSearchFields(
    undefined,
    ["driverId", "driverName", "email"],
    resourceNames.ADMIN_DRIVERS_VIEW
  );

  useEffect(() => {
    form.registerField(source, () => {}, { value: true });
  }, [form, source]);

  useEffect(() => {
    form.change(source, ids);
  }, [ids, form, source]);

  const mergedFilter = useMemo(
    () => ({
      ...(filter ?? {}),
      ...(searchText ? { q: searchText } : {}),
    }),
    [filter, searchText]
  );

  return (
    <>
      <Box mb={2}>
        <MuiTextField
          fullWidth
          label="Search drivers"
          variant="outlined"
          size="small"
          value={searchText}
          onChange={(event) => setSearchText(event.target.value)}
        />
      </Box>
      <ArrayInput source={source}>
        <ListIterator
          reference={resourceNames.ADMIN_DRIVERS_VIEW}
          sort={{ field: "driverName", order: "asc" }}
          filter={mergedFilter}
        >
          <TextField
            source="driverId"
            label="resources.admin-drivers.labels.driverId"
          />
          <TextField
            source="driverName"
            label="resources.admin-drivers.labels.displayName"
          />
        </ListIterator>
      </ArrayInput>
    </>
  );
};
